import { State } from "../types/State";

export function initStateFromLocation() {
  const searchParams = new URLSearchParams(location.search);
  const state: State = {};

  for (const [key, value] of searchParams.entries()) {
    const decodedValue = decodeURIComponent(value);

    if (key === "prix") {
      const price = decodedValue.split(",");
      state["prix-min"] = price[0];
      state["prix-max"] = price[1];
    } else if (key === "surface") {
      state["surface-min"] = decodedValue;
    } else if (key === "ville") {
      const ville = decodedValue.split(",");
      state["code-postal"] = ville[0];
      state["ville"] = ville[1];
      ville[2] && (state["localite-range"] = ville[2]);
    } else {
      state[key] = decodedValue.split(",");
    }
  }

  return state;
}
